module.exports = __webpack_public_path__ + "img/头像.77dfbe36.png";